const SEARCH = "SEARCH";
const EXPERT_PROFILE_PAGE = "EXPERT_PROFILE_PAGE";
const FILTER = "FILTER";
const MORE_RESULT = "MORE_RESULT";
const PROFILE_VIEW = "PROFILE_VIEW";
const AUTH = "AUTH";
const PEER_REVIEW = "PEER_REVIEW"
const AFFILIATION_PROFILE_VIEW = "AFFILIATION_PROFILE_VIEW";
const FAILURE = "FAILURE";
const SENIORITY_SCHEMA = "SENIORITY_SCHEMA";
const MLD_SEARCH = "MLD_SEARCH";
const KOL_MAPPING = "KOL_MAPPING";
const TRIAL_INSTITUTE_RECRUITERS = "TRIAL_INSTITUTE_RECRUITERS";
const TRIAL_END_POINTS = "TRIAL_END_POINTS"

module.exports = {
    SEARCH,
    EXPERT_PROFILE_PAGE,
    FILTER,
    MORE_RESULT,
    PROFILE_VIEW,
    AUTH,
    PEER_REVIEW,
    AFFILIATION_PROFILE_VIEW,
    FAILURE,
    SENIORITY_SCHEMA,
    MLD_SEARCH,
    KOL_MAPPING,
    TRIAL_INSTITUTE_RECRUITERS,
    TRIAL_END_POINTS
}